"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var base_1 = require("./base");
var helper_1 = require("../utils/helper");
var constants_1 = require("../utils/constants");
var __1 = require("..");
// 存储到 IndexedDB 中
var setIntoIndexedDB = function (key, config) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, __1.Config.storeConfigInIndexedDB(key, config)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
var fetchConfig = function (path, cacheKey) { return __awaiter(void 0, void 0, void 0, function () {
    var response, data, error_1, cacheData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, fetch(path)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                data = _a.sent();
                setIntoIndexedDB(cacheKey, data);
                return [2 /*return*/, data];
            case 3:
                error_1 = _a.sent();
                console.warn("Elvish Warning: \u8BF7\u6C42".concat(cacheKey, "\u914D\u7F6E\u5931\u8D25"));
                return [4 /*yield*/, __1.Config.getFromIndexedDB(cacheKey)];
            case 4:
                cacheData = _a.sent();
                if (cacheData) {
                    return [2 /*return*/, cacheData];
                }
                throw error_1;
            case 5: return [2 /*return*/];
        }
    });
}); };
// 获取 cdn 配置并存储到 IndexedDB
var getRemoteConfig = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _a, cityMap, countryTimezone, timezone, error_2, cityMap, countryTimezone, timezone, _b, cityMap_1, countryTimezone_1, timezone_1, foodErrMsg, isFoodErrMsg, error_3, cityMap_2, countryTimezone_2, timezone_2;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 12]);
                return [4 /*yield*/, Promise.all([
                        fetchConfig(helper_1.cityMapCDNPath, constants_1.ConfigMap.ELVISHCITYMAP),
                        fetchConfig(helper_1.countryTimezoneCDNPath, constants_1.ConfigMap.ELVISHCOUNTRYTIMEZONE),
                        fetchConfig(helper_1.timezoneCDNPath, constants_1.ConfigMap.ELVISHTIMEZONE)
                    ])];
            case 1:
                _a = _c.sent(), cityMap = _a[0], countryTimezone = _a[1], timezone = _a[2];
                return [4 /*yield*/, (0, base_1.initBase)({ cityMap: cityMap, countryTimezone: countryTimezone, timezone: timezone })];
            case 2:
                _c.sent();
                return [3 /*break*/, 12];
            case 3:
                error_2 = _c.sent();
                console.warn("Elvish Warning: ".concat(error_2.message));
                if (!(typeof window !== 'undefined')) return [3 /*break*/, 11];
                return [4 /*yield*/, __1.Config.getFromIndexedDB(constants_1.ConfigMap.ELVISHCITYMAP)];
            case 4:
                cityMap = _c.sent();
                return [4 /*yield*/, __1.Config.getFromIndexedDB(constants_1.ConfigMap.ELVISHCOUNTRYTIMEZONE)];
            case 5:
                countryTimezone = _c.sent();
                return [4 /*yield*/, __1.Config.getFromIndexedDB(constants_1.ConfigMap.ELVISHTIMEZONE)];
            case 6:
                timezone = _c.sent();
                if (!(!cityMap || !countryTimezone || !timezone)) return [3 /*break*/, 10];
                _c.label = 7;
            case 7:
                _c.trys.push([7, 9, , 10]);
                return [4 /*yield*/, Promise.all([
                        fetchConfig(helper_1.cityMapCDNPath, constants_1.ConfigMap.ELVISHCITYMAP),
                        fetchConfig(helper_1.countryTimezoneCDNPath, constants_1.ConfigMap.ELVISHCOUNTRYTIMEZONE),
                        fetchConfig(helper_1.timezoneCDNPath, constants_1.ConfigMap.ELVISHTIMEZONE)
                    ])];
            case 8:
                _b = _c.sent(), cityMap_1 = _b[0], countryTimezone_1 = _b[1], timezone_1 = _b[2];
                foodErrMsg = 'Unexpected token v in JSON at position 0 date';
                isFoodErrMsg = foodErrMsg.indexOf(error_2.message) > -1;
                return [2 /*return*/, (0, base_1.initBase)({ cityMap: cityMap_1, countryTimezone: countryTimezone_1, timezone: timezone_1 }, isFoodErrMsg ? foodErrMsg : '').then(function (res) {
                        // 外卖的碰到的奇怪的报错：Unexpected token v in JSON at position 0，针对这种情况需要返回这个错误做一下统计
                        return res;
                    })];
            case 9:
                error_3 = _c.sent();
                // 二次拉取失败并且也无缓存可用
                // throw Error(`Elvish Fetch Error: ${err.message}`);
                console.warn("Elvish Fetch Warning: ".concat(error_3.message));
                cityMap_2 = (0, helper_1.getApolloConfigFromLocal)(constants_1.Flag.CITYMAP);
                countryTimezone_2 = (0, helper_1.getApolloConfigFromLocal)(constants_1.Flag.COUNTRYTIMEZONE);
                timezone_2 = (0, helper_1.getApolloConfigFromLocal)(constants_1.Flag.TIMEZONE);
                return [2 /*return*/, (0, base_1.initBase)({ cityMap: cityMap_2, countryTimezone: countryTimezone_2, timezone: timezone_2 })];
            case 10: return [2 /*return*/, (0, base_1.initBase)({ cityMap: cityMap, countryTimezone: countryTimezone, timezone: timezone })];
            case 11: return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}); };
var fetchAndCache = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _a, cityMap, countryTimezone, timezone, err_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, Promise.all([
                        fetch(helper_1.cityMapCDNPath).then(function (res) { return res.json(); }),
                        fetch(helper_1.countryTimezoneCDNPath).then(function (res) { return res.json(); }),
                        fetch(helper_1.timezoneCDNPath).then(function (res) { return res.json(); })
                    ])];
            case 1:
                _a = _b.sent(), cityMap = _a[0], countryTimezone = _a[1], timezone = _a[2];
                setIntoIndexedDB(constants_1.ConfigMap.ELVISHCITYMAP, cityMap);
                setIntoIndexedDB(constants_1.ConfigMap.ELVISHCOUNTRYTIMEZONE, countryTimezone);
                setIntoIndexedDB(constants_1.ConfigMap.ELVISHTIMEZONE, timezone);
                return [3 /*break*/, 3];
            case 2:
                err_1 = _b.sent();
                console.warn('Elvish Warning: update remote config IndexedDB error', err_1);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
var initialize = function (config) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, base_1.initBase)(config)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
var getRemoteConfigAndCatchError = function () {
    return getRemoteConfig().catch(function (err) {
        console.error(err);
        throw new Error('Unexpected token v in JSON at position 0');
    });
};
// eslint-disable-next-line import/prefer-default-export
var init = function (_a) {
    var config = _a.config, ifCache = _a.ifCache, forceInit = _a.forceInit;
    return __awaiter(void 0, void 0, void 0, function () {
        var cityMap, countryTimezone, timezone;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (forceInit) {
                        base_1.DateFormat.inited = false;
                    }
                    if (base_1.DateFormat.inited)
                        return [2 /*return*/, new Promise(function (resolve) { return resolve(''); })];
                    if (!config) return [3 /*break*/, 1];
                    initialize(config);
                    return [3 /*break*/, 6];
                case 1:
                    if (!(typeof window !== 'undefined' && ifCache)) return [3 /*break*/, 5];
                    return [4 /*yield*/, __1.Config.getFromIndexedDB(constants_1.ConfigMap.ELVISHCITYMAP)];
                case 2:
                    cityMap = _b.sent();
                    return [4 /*yield*/, __1.Config.getFromIndexedDB(constants_1.ConfigMap.ELVISHCOUNTRYTIMEZONE)];
                case 3:
                    countryTimezone = _b.sent();
                    return [4 /*yield*/, __1.Config.getFromIndexedDB(constants_1.ConfigMap.ELVISHTIMEZONE)];
                case 4:
                    timezone = _b.sent();
                    if (!cityMap || !countryTimezone || !timezone) {
                        getRemoteConfigAndCatchError();
                    }
                    initialize({
                        cityMap: cityMap,
                        countryTimezone: countryTimezone,
                        timezone: timezone
                    });
                    fetchAndCache();
                    return [3 /*break*/, 6];
                case 5:
                    getRemoteConfigAndCatchError();
                    _b.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    });
};
exports.init = init;
